import { gsap } from "gsap";

import { ScatterStates, UCSymbolNames } from "../../../types/UCEnums";
import { UCSymbol } from "./UCSymbol";

export class UCScatterSymbol extends UCSymbol {
    protected currentState: ScatterStates;

    constructor() {
        super(UCSymbolNames.SCATTER);

        this.currentState = ScatterStates.NORMAL;
    }

    override getLandingAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.mainSpine.getSpineTween(`Landing`);
    }

    public override getWinAnimation(
        scatterState: ScatterStates = ScatterStates.NORMAL
    ): gsap.core.Tween | gsap.core.Timeline {
        const initialState = this.currentState;
        this.currentState = scatterState;

        switch (scatterState) {
            case ScatterStates.WIN: {
                this.mainSpine.state.setAnimation(0, `Win`, true).mixDuration = 0.2;

                break;
            }

            case ScatterStates.LOSE:
                if (initialState === ScatterStates.ANTICIPATION) {
                    this.mainSpine.state.setAnimation(0, `Anticipation_fail`, false);
                } else {
                    this.mainSpine.state.setAnimation(0, `Normal`, false);
                }
                break;

            case ScatterStates.ANTICIPATION:
                if (initialState !== ScatterStates.ANTICIPATION) {
                    this.mainSpine.reset();
                    this.mainSpine.state.setAnimation(0, `Anticipation`, true);
                }
                break;

            default:
                this.mainSpine.state.setAnimation(0, `Normal`, false);
        }

        return gsap.to({}, {});
    }

    public getStopWinAnimation(): gsap.core.Tween {
        return this.mainSpine.getSpineTween(`Normal`);
    }

    override reset() {
        super.reset();
    }

    resetOnStartSpin() {
        super.resetOnStartSpin();

        this.currentState = ScatterStates.NORMAL;
    }
}
